import { validatePresence } from 'ember-changeset-validations/validators';
import { customMessageValidator } from 'uplisting-frontend/validators/custom-message';

export const MultiUnitValidation = {
  name: customMessageValidator(
    'multi_unit_name',
    validatePresence({
      presence: true,
      ignoreBlank: true,
    }),
  ),
};
